import { formatDate } from '@artosera/shared';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useConsultationHorsLigne } from '../../horsLigne/index.js';
import { useEnLigne } from './BandeauHorsLigne.js';
import styles from './BandeauHorsLigne.module.css';

/** « Fiche du … » sous le titre d'une fiche, hors ligne seulement (M11). */
export function IndicateurFraicheur({ depuis }: { readonly depuis: number }): JSX.Element | null {
  const { t, i18n } = useTranslation('regie');
  const enLigne = useEnLigne();
  const consultation = useConsultationHorsLigne();
  if ((enLigne && !consultation) || depuis <= 0) return null;
  const langue = i18n.language === 'en' ? 'en' : 'fr';
  return (
    <p className={styles.fraicheur}>
      {t('horsLigne.ficheDu', { date: formatDate(new Date(depuis), langue, 'court') })}
    </p>
  );
}
